export class HistoricoCargue {
    nombre: string;
    credencial: string;
    fecha: Date;
    estado: string;
    usuario: string;

    constructor() {
        this.nombre = "",
            this.credencial = "",
            this.fecha = null,
            this.estado = "",
            this.usuario = ""
    }
}